import { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { itemIdMatch } from '~src/constants';
import ScaleAdd from '~src/modules/scales/components/add/ScaleAdd';
import ScaleDetails from '~src/modules/scales/components/details/ScaleDetails';
import ScalesList from '~src/modules/scales/components/list/ScalesList';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import PageNotFound from '~src/shared/errorPages/PageNotFound';
import { fetchLocales, fetchTimeZones } from '~src/store/session/actions';

interface DispatchProps {
  fetchTimeZones(): ApiReduxResp;
  fetchLocales(): ApiReduxResp;
}

interface OwnProps {
  isAuthenticated: boolean;
}

type Props = OwnProps & DispatchProps & RouteComponentProps<any>;

const Scales: FC<Props> = (props) => {
  useEffect(() => {
    if (props.isAuthenticated) {
      props.fetchTimeZones();
      props.fetchLocales();
    }
  }, []);

  return (
    <Switch>
      <Route exact strict path={props.match.url} component={ScalesList} />
      <Route exact strict path={`${props.match.url}/add`} component={ScaleAdd} />
      <Route exact strict path={`${props.match.url}/:scaleId(${itemIdMatch})`} component={ScaleDetails} />
      <PageNotFound {...props} />
    </Switch>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  fetchTimeZones: () => dispatch(fetchTimeZones()),
  fetchLocales: () => dispatch(fetchLocales()),
});

const ScalesC = connect(null, mapDispatchToProps)(Scales);

export default ScalesC;
